import axios from "axios";
import { useNavigate } from "react-router-dom";

const apiUrl = process.env.REACT_APP_API_URL;

// Create an Axios instance
const axiosInstance = axios.create({
  baseURL: apiUrl,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request Interceptor: Attach Page Info
axiosInstance.interceptors.request.use((config) => {
  // Attach the current path as `page`
  config.headers["X-Requested-Page"] = window.location.pathname;
  return config;
});

// Response Interceptor: Handle Unauthorized Access
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      const requestedPage = error.response.data.page || "/login";
      console.log("Redirecting due to Token expired:", requestedPage);
      window.location.href = "/login";
    }

    if (error.response && error.response.status === 403) {
      const requestedPage = error.response.data.page || "/unauthorized";
      console.log("Redirecting due to lack of permission:", requestedPage);
      window.location.href = "/unauthorized";
    }
    
    return Promise.reject(error);
  }
);

export default axiosInstance;
